import { createContext } from 'react'

const BadgeContext = createContext()

export default BadgeContext
